module.exports = __webpack_public_path__ + "img/step1-dark.ac69aa7f.png";